export interface IDisplayDurationProps {time: string}

const DisplayDuration: React.FC<IDisplayDurationProps> = ({time}) => {
    const valueArray = `${time}`.split('');
    const timeString = `${valueArray.length === 6 ? valueArray[5] : 0}${valueArray.length === 5 ? valueArray[4] : 0}:${valueArray.length === 4 ? valueArray[3] : 0}${valueArray.length === 3 ? valueArray[2] : 0}:${valueArray.length === 2 ? valueArray[1] : 0}${valueArray.length === 1 ? valueArray[0] : 0}`
    return <p className={"standardText"}>{timeString}</p>
}

export default DisplayDuration;